<template>
    <!--
        The neutral state the app wears until the router has decided where the first navigation
        lands (V17, §9.1). It is the *only* thing that may render before that decision: the
        Default shell is the dashboard, and a dashboard drawn for a visitor whose session has not
        been established yet is both a lie and — because the shell starts polling on mount — four
        requests that will 401.

        Same centering as `Blank.vue`, no sidebar, no topbar, nothing that reads the session. It
        paints nothing: the body rule in `theme/theme.css` owns the canvas (vue-spec theme.md).
    -->
    <div class="flex flex-col items-center justify-center min-h-dvh gap-4">
        <UIcon name="i-lucide-loader-circle" class="size-8 text-primary animate-spin" />
        <p class="sr-only">{{ $t('general.loading') }}</p>
    </div>
</template>
